import React from 'react'
import { ReactComponent as NoImage } from 'assets/icons/no_image.svg';

import style from '../styles/product_card.module.scss'
export const EmptyIcon = ({minHeight = '180px'}) => {
  return (
    <div className={style.product_card__image_empty_wrapper} style={{minHeight: minHeight}}>
      <NoImage className={style.product_card__image_empty} width={70} height={55} />
    </div>
  )
}
